import { Form as FormikForm } from "formik"

import {
    FormikButtonSubmit as UiFormikButtonSubmit,
    FormHelperText as UiFormHelperText,
    FormikTextField as UiFormikField,
    Typography,
    styled,
} from "@l2r-front/l2r-ui"

export const FormikButtonSubmit = styled(UiFormikButtonSubmit)({
    alignSelf: "flex-end",
    width: "fit-content",
})

export const Form = styled(FormikForm)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(4),
}))

export const TokenInput = styled(UiFormikField)({
    margin: 0,
})

export const Text = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(8),
    whiteSpace: "pre-line",
}))

export const PasswordInput = styled(UiFormikField)({
    marginBottom: 0,
})

export const ButtonsWrapper = styled("div")({
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
})

export const FormikTextField = styled(UiFormikField)(({ theme }) => ({
    marginBottom: theme.spacing(8),
}))
export const FormHelperText = styled(UiFormHelperText)({
    position: "relative",
    top: -20,
})
